<template>
    <MoreBlogsComponent/>
</template>

<script>
import MoreBlogsComponent from '../components/moreblog/MoreBlogsComponent.vue'

export default {
  name: 'MoreBlogsView',
  components: {
    MoreBlogsComponent
  }
}
</script>